<template>
    <li class="mMenuCol">
        <div class="menuDiscount">
            <div class="discountImg"><img
                    :src="image_url" alt=""></div>
            <span>{{ small_text }}</span>
            <div class="h3">{{ big_text }}</div>
            <a :href="action_url ">{{ action_text }}</a>
        </div>
    </li>
</template>

<script>
export default {
  name: 'quick-try-now-menu',
  props: ['small_text', 'big_text', 'action_text', 'action_url', 'image_url']
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tryNowMenu.vue